import { Breadcrumbs } from '@wix/design-system';
import { ReactElement } from 'react';
import { useCollectionPageHeader } from '../../state/CollectionPage';
import { MoreActionsElement } from '../MoreActions';
import { PrimaryPageButtonElement } from '../PrimaryPageButton';

export interface CollectionPageHeaderProps {
  /**
   * Page breadcrumbs
   */
  breadcrumbs?: ReactElement<Breadcrumbs>;

  /**
   * Page title text
   */
  title: { text: string };

  /**
   * Page subtitle text
   */
  subtitle?: { text: string };

  /**
   * <PrimaryPageButton />
   */
  primaryAction?: PrimaryPageButtonElement;

  /**
   * <MoreActions />
   */
  moreActions?: MoreActionsElement;
}

export type CollectionPageHeaderElement = ReactElement<
  CollectionPageHeaderProps,
  typeof CollectionPageHeader
>;

export function CollectionPageHeader(_props: CollectionPageHeaderProps) {
  return null;
}

CollectionPageHeader.useCollectionPageHeader = useCollectionPageHeader;
CollectionPageHeader.displayName = 'CollectionPageHeader';
